import { render, staticRenderFns } from "./CollectionPlanInfo.vue?vue&type=template&id=a4ee4db4&scoped=true"
import script from "./CollectionPlanInfo.vue?vue&type=script&lang=js"
export * from "./CollectionPlanInfo.vue?vue&type=script&lang=js"
import style0 from "./CollectionPlanInfo.vue?vue&type=style&index=0&id=a4ee4db4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ee4db4",
  null
  
)

export default component.exports